$ = jQuery;
var main = {};
var win = $(window);
var doc = $(document);

main = {
  defaults: {
  },
  onInit: function() {
    var vm = this;
  },
  onReady: function(e) {
    var vm = this;
    var el = vm.defaults;
		vm.onInit();
    vm.onResize();
    vm.animateOnReady();
    vm.modalToggle();
    vm.megamenuBlogToggle();
    vm.setEqualMegamenuText();
    if (theme.storeLocation == 'AU')
      vm.priceLineFunctions();
    if ($('#ProductSelect-product-template').length > 0) {
      try {
        sheetSet.onInit();
      } catch (error) {}
    }
      
    if ($('body').hasClass('template-index')) {
      $('.btn-newsletter-trigger').on('click', function() {
        vm.modalTrigger('newsletter-popup');
      });
    }
    setTimeout(function() {
      $('.product-single__photos-slider').removeClass('loading');
      $('.product-single__thumbnails-wrapper').removeClass('loading');
    },2300);
    //vm.loadUpsellGlobal();
    // vm.collectionSelect();

    GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
      $('body').attr('data-country', geoData.countryCode);
    });

    $(document).on('click', '.bn-pl-popup .bg-close, .bn-pl-popup .cta-close-popup', function() {
      $('body').removeClass('bn-pl-popup-active');
    });
    $(document).on('click', '.bn-pl-wrapper .p-item-learnmore a', function(e) {
      e.preventDefault();
      var paymentType = $(this).parents().eq(1).attr('data-payment-type');
      console.log(paymentType);
      $('.bn-pl-popup .inner-wrapper .payment-item[data-name="'+paymentType+'"]').addClass('active').siblings().removeClass('active');
      $('body').addClass('bn-pl-popup-active');
    });
    $(document).on('click', '.bn-pl-wrapper .p-item-logo', function(e) {
      e.preventDefault();
      var paymentType = $(this).parent().attr('data-payment-type');
      console.log(paymentType);
      $('.bn-pl-popup .inner-wrapper .payment-item[data-name="'+paymentType+'"]').addClass('active').siblings().removeClass('active');
      $('body').addClass('bn-pl-popup-active');
    });

    if ($('body').hasClass('loop-returns-activated')) {
      $('.checkout-btn-cta').text('Use Credits');
      $('input.checkout-btn-cta').val('Use Credits');
    }
  },
  onLoad: function(e) {
    var vm = this;
    var el = vm.defaults;
/*
    if (getCookie('newsletterOnce') == '' || getCookie('newsletterOnce') == undefined) {
      vm.triggerNewsLetterPopupOnce();
    }
*/
    vm.encryptEmail();

    // setTimeout(function() {
    //   $(window).scrollTop(0); // scroll to top on load
    // }, 1);
  },
  onResize: function(e) {
    var headerHeight = $('.site-header').outerHeight();
    // $('#PageContainer').css({'margin-top': headerHeight+'px'});
    $('.site-nav .megamenu-overlay').css({'top': headerHeight+'px'});

  },
  onScroll: function(e) {
    var vm = this;
    var st = win.scrollTop();
    var heroHeader = $('.section--hero-image');

    vm.animateScrollTransition();

    if (heroHeader.length > 0 && $('body').hasClass('template-index')) {
      var heroHeight = heroHeader.outerHeight() + $('.site-header').outerHeight();
    }
    if (st > vm.defaults.lastScrollTop) {
      // scroll down
    } else {
      // scroll up
    }

    if (st > heroHeight) {
      $('.btn-subscribe-wrapper').addClass('show-btn');
    } else {
      $('.btn-subscribe-wrapper').removeClass('show-btn');
    }
    vm.defaults.lastScrollTop = st;
  },
  triggerNewsLetterPopupOnce: function() {
    var vm = this;

    vm.modalTrigger('newsletter-popup');
    if ($('body').attr('data-handle') != 'competition') {
      setCookie('newsletterOnce', true, 1);
    }
  },
  modalTrigger: function(modalElem) {
    $('.modal-fullscreen-wrapper[data-modal="'+modalElem+'"').toggleClass('modal-active');
  },
  modalToggle: function() {
    $('.modal-overlay, .modal-close').on('click', function() {
      $(this).closest('.modal-fullscreen-wrapper').removeClass('modal-active');
    });
  },
  loadUpsellGlobal: function() {
    if ($('.collection-grid-wrapper').length > 0) {
      var firstGridForm = $('.collection-grid-wrapper .grid__item--collection-template').eq(0).find('form');
      var upsellID = firstGridForm.attr('data-prodid');
      for(i=0; i<3; i++){
        if (productUpsellData[upsellID] != undefined && productUpsellData[upsellID]['upsell_data'][i] != undefined) {
          $('.upsell-popup-wrapper .grid__item').eq(i).removeClass('hide');
          $('.upsell-popup-wrapper .grid__item').eq(i).find('.grid-view-item__image-wrapper .grid-view-item__image-main').attr('src', productUpsellData[upsellID]['upsell_data'][i]['upsell_image']);
          $('.upsell-popup-wrapper .grid__item').eq(i).find('.grid-view-item__image-wrapper .grid-view-item__image-second').attr('src', productUpsellData[upsellID]['upsell_data'][i]['upsell_image_hover']);
          $('.upsell-popup-wrapper .grid__item').eq(i).find('.full-width-link').attr('href', productUpsellData[upsellID]['upsell_data'][i]['upsell_url']);
          $('.upsell-popup-wrapper .grid__item').eq(i).find('a .product-card__title').text(productUpsellData[upsellID]['upsell_data'][i]['upsell_title']);
        } else {
          $('.upsell-popup-wrapper .grid__item').eq(i).addClass('hide');
        }
      }
    }
  },
  collectionSelect: function() {
    $('form[action="/cart/add"].quick-addtocart-form').on('submit', function() {
      var thisForm = $(this);
      var upsellID = thisForm.attr('data-prodid');
      for(i=0; i<3; i++){
        if (productUpsellData[upsellID] != undefined && productUpsellData[upsellID]['upsell_data'][i] != undefined) {
          $('.upsell-popup-wrapper .grid__item').eq(i).removeClass('hide');
          $('.upsell-popup-wrapper .grid__item').eq(i).find('.grid-view-item__image-wrapper .grid-view-item__image-main').attr('src', productUpsellData[upsellID]['upsell_data'][i]['upsell_image']);
          $('.upsell-popup-wrapper .grid__item').eq(i).find('.grid-view-item__image-wrapper .grid-view-item__image-second').attr('src', productUpsellData[upsellID]['upsell_data'][i]['upsell_image_hover']);
          $('.upsell-popup-wrapper .grid__item').eq(i).find('.full-width-link').attr('href', productUpsellData[upsellID]['upsell_data'][i]['upsell_url']);
          $('.upsell-popup-wrapper .grid__item').eq(i).find('a .product-card__title').text(productUpsellData[upsellID]['upsell_data'][i]['upsell_title']);
        } else {
          $('.upsell-popup-wrapper .grid__item').eq(i).addClass('hide');
        }
      }
    });
  },
  encryptEmail: function() {
    var userEmailAdd = $('.email-encrypt').attr('data-user');
    var userDomain = $('.email-encrypt').attr('data-domain');

    $(doc).on('click', '.email-encrypt', function(e) {
      e.preventDefault();
      window.location.href = 'mailto:'+userEmailAdd+'@'+userDomain;
    });
  },
  megamenuBlogToggle: function() {
    var link = $(".megamenu-blog-mm .quick-links a")
    var row = $(".megamenu-blog-mm .row")
    link.mouseover(function() {
      var _this = $(this),
          target = _this.attr('data-handle')

      if( $(`.megamenu-blog-mm .row.${target}`).length ) {
        row.removeClass('active')
        $(`.megamenu-blog-mm .row.${target}`).addClass('active')
      }

    })
  },
  setEqualMegamenuText: function() {
    var mmText = $('.megamenu-blog-mm .mm-grid-text')
    var computedHeight = 0;
    mmText.each(function() {
      if( $(this).height() > computedHeight ) {
        computedHeight = $(this).height()
      }
    })
    mmText.height(computedHeight)
  },
  animateScrollTransition: function() {
    var st = $(window).scrollTop();
    var winHeight = $(window).height();
    $(document).find('.animate-appear').each(function() {
      var thisTop = $(this).offset().top;
      if (st >= (thisTop - (winHeight / 1.25)) ) {
        // $(this).addClass('displayed');
        if ($(this).hasClass('latest-article-wrapper')) {
          $(this).find('.home-tours-item').each(function() {
            var thisDuration = $(this).attr('data-anim-duration');
            var thisDelay = $(this).attr('data-anim-delay');
            $(this).css({
              'opacity': 1,
              'transform': 'translateY(0)',
              'transition': `transform ${thisDuration}ms ease-in-out ${thisDelay}ms, opacity ${thisDuration}ms ease-in-out ${thisDelay}ms`
            });
          });
        } else {
          var thisDuration = $(this).attr('data-anim-duration');
          var thisDelay = $(this).attr('data-anim-delay');
          $(this).css({
            'opacity': 1,
            'transform': 'translateY(0)',
            'transition': `transform ${thisDuration}ms ease-in-out ${thisDelay}ms, opacity ${thisDuration}ms ease-in-out ${thisDelay}ms`
          });
        }
      }
    });
  },
  animateOnReady: function() {
    $(document).find('.hero__inner .animate-appear').each(function() {
      var thisDuration = $(this).attr('data-anim-duration');
      var thisDelay = $(this).attr('data-anim-delay');
      $(this).css({
        'opacity': 1,
        'transform': 'translateY(0)',
        'transition': `transform ${thisDuration}ms ease-in-out ${thisDelay}ms, opacity ${thisDuration}ms ease-in-out ${thisDelay}ms`
      });
    });
  },
  priceLineFunctions: function() {
    var vm = this;
    var urlParams = new URLSearchParams(window.location.search);
    var pricelineParameter = urlParams.get('priceline'); //extract the foo parameter - this will return NULL if foo isn't a parameter
    var sisterClubIdParameter = urlParams.get('scid');
    if(pricelineParameter) { //check if foo parameter is set to anything
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'pricelineModalView',
      });
       $('body').addClass('priceline-active');
       vm.setCookie('priceline', 'active', 1);
    }
    if (sisterClubIdParameter) {
      $('.priceline-popup-wrapper #sister-club-num').val(sisterClubIdParameter);
    }
    $('.priceline-popup-wrapper button[type="submit"]').on('click', function(e) {
        var carNumber = $('.priceline-popup-wrapper #sister-club-num').val();
        e.preventDefault();
        $.ajax({
          type: 'GET',
          url: 'https://australia-southeast1-priceline-partnership.cloudfunctions.net/verifyMembership?card_number='+carNumber,
          async: false,
          dataType: 'json',
          success: function(response) {
            if (response.data.message == 'Valid Card Number') {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'pricelineModalSubmitSuccess',
              });
              $('.priceline-popup-wrapper').addClass('valid');
              console.log('resp', response);
              console.log('priceline cookie', getCookie('priceline'));
              vm.setCookie('priceline', 'active', 1);
              vm.setCookie('priceline-id', carNumber, 1);
            }
            $('.priceline-popup-wrapper .pl-input-container').removeClass('input-error');
          },
          error: function() {
            $('.priceline-popup-wrapper .pl-input-container').addClass('input-error');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'pricelineModalSubmitFail',
            });
            vm.setCookie('priceline', 'active', 1);
            vm.setCookie('priceline-id', '', 1);
          }
        });
    });
    $('.priceline-popup-wrapper #sister-club-num').on('keyup', function() {
      $(this).parent().removeClass('input-error');
    });
    $('.priceline-popup-wrapper .close-pl-popup').on('click', function(e) {
      e.preventDefault();
      if($('.priceline-popup-wrapper').hasClass('valid')) {
        var thisLink = '/discount/SISTERCLUB10?redirect=/collections/';
        window.location.href = thisLink;
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'pricelineModalClose',
        });
      }
      $('body').removeClass('priceline-active');
    });
    $('.priceline-popup-wrapper .pl-thank-content .shop-now-cta').on('click', function(e) {
      e.preventDefault();
      var thisLink = '/discount/SISTERCLUB10?redirect=/collections/';
      window.location.href = thisLink;
    })
  },
  setCookie: function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
};
doc.ready(function() {
  main.onReady();
});

win.on('load', function() {
  main.onLoad();
});

win.resize(function() {
  main.onResize();
});

win.scroll(function() {
  main.onScroll();
});

$(window).bind("pageshow", function(event) {
  if (event.originalEvent.persisted) {
    updateCartDrawer();
  }
});